import { createSelector } from "@reduxjs/toolkit";

import type { MultilingualNodeConfig } from "../../schemas/index.ts";
import { nodeDesignsByIdSelector } from "./nodeDesignsCoreSelectors.ts";

type GetMultilingualNodeConfig = (id: number) => MultilingualNodeConfig;

export const getMultilingualNodeConfigSelector = createSelector(
  nodeDesignsByIdSelector,
  (byId): GetMultilingualNodeConfig =>
    (id: number) =>
      byId[id]?.config,
);
